/**
 * Converts an image file to PNG format using Canvas API
 * @param {File} file - The image file to convert
 * @returns {Promise<File>} - A promise that resolves to a PNG File
 */
export const convertImageToPng = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(
        (blob) => {
          if (blob) {
            const pngFile = new File(
              [blob],
              file.name.replace(/\.[^.]+$/, ".png"),
              {
                type: "image/png",
              }
            );
            resolve(pngFile);
          } else {
            reject(new Error("Failed to convert image"));
          }
        },
        "image/png"
      );
    };
    img.onerror = () => reject(new Error("Failed to load image"));
    img.src = URL.createObjectURL(file);
  });
};
